.cancel-discount {
  &__abort-link {
    color: var(--sc-input-help-text-color);
  }
}
